<template>
  <div>
      <button @click="addHui">ADD HUI</button>
  </div>
</template>

<script>
import eventBus from './eventBus'

export default {
    methods: {
        addHui(){
            eventBus.$emit('four::add-letter','hui');
        }
    },
}
</script>

<style>

</style>